import React, { useEffect, useRef, useState } from "react";
import { Link, withRouter } from "react-router-dom";
import { useWindowSize } from "@react-hook/window-size";
import application_contants from "../../constants/application_contant";



const ExternalHeader = (props) => {
    const [width] = useWindowSize();
    const [isToggle, setIsToggle] = useState(false);
    const [isMegaMenu, setIsMegaMenu] = useState(true);
    const [isAnimate, setIsAnimate] = useState(false);

    

 
    return (
        <div className=''>
        <div className={`header-container ` }>
          
                <div className="d-flex justify-content-between menu-container">
                    <div className="d-flex  align-items-center logo-icon position">
                        <div>
                            {/* <Link to={'/'}> */}
                                <img src={application_contants.brand} alt="" className="cursor-pointer" />
                            {/* </Link> */}
                        </div>
                    </div>
                    {/* <div>
                    <img src={application_contants.brand} alt="" className="cursor-pointer menu-icon4" />
                    </div> */}
                    <div className="p-large search-container menu-icon3 ">
                            <input type="text" className="p-very-small" placeholder="Search by patient id or name" />
                         {/* <button>Search</button> */}
                            </div>
                            <div>
                    <p className="h5-small section-title title-white cursor-pointer menu-icon5">Antlia Web </p>
                    </div>
                    <div>
                    <img src={application_contants.icon} alt="" className="cursor-pointer menu-icon2" />
                    </div>
                    <div>
                    <img src={application_contants.user} alt="" className="cursor-pointer menu-icon1" />
                    </div>
                    <div>
                        <img src={application_contants.dropList} alt="" className="cursor-pointer menu-icon " />
                    
                    </div>
                    
                        
    
                  </div>  
        
                    
               
        </div>
        </div>
    )
}
export default withRouter(ExternalHeader);
